module.exports = __webpack_public_path__ + "img/xxing.56307485.jpg";